var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['columns ugc-top-bar-steps-view-instructions', {
      'small-9': !_vm.$store.state.utils.configuration.enableNewUgcModal && !_vm.customizerHeaderUGCLargeButton
    }, {
      'small-8': !_vm.$store.state.utils.configuration.enableNewUgcModal && _vm.customizerHeaderUGCLargeButton
    }],
    attrs: {
      "id": "customs-vmodal-header-title"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.translations.ugcStep) + " " + _vm._s(_vm.currentStep) + " " + _vm._s(_vm.translations.ugcStepOf) + "\n  " + _vm._s(_vm.totalSteps) + " " + _vm._s(_vm.translations.ugcStepEnd) + ": " + _vm._s(_vm.getTitle) + " "), _c('br'), _vm._v("\n  " + _vm._s(_vm.getSubTitle) + " " + _vm._s(_vm.displayViewText) + "\n")]);
}
var staticRenderFns = []

export { render, staticRenderFns }